import React from 'react';

const WidgetMeteo = ({width = 20, height = 20, couleur = "#A8B0B3"}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 40 28" fill="none">
        <g clipPath="url(#clip0_3880_18558)">
            <path
                d="M35.5394 14.0962C34.6518 12.8237 33.2644 11.9267 31.6598 11.6939C31.514 7.86401 29.0993 4.61448 25.7194 3.25507C24.6269 2.81435 23.432 2.57227 22.1813 2.57227C17.532 2.57227 13.6679 5.91491 12.8516 10.3283C12.1471 10.0707 11.3836 9.92795 10.5891 9.92795C6.94848 9.92795 4 12.8795 4 16.517C4 20.1545 6.65984 22.8019 10.0397 23.0813V23.1061H31.6691V23.044C34.4407 22.6374 36.5667 20.2538 36.5667 17.3705C36.5667 16.1539 36.185 15.0242 35.5394 14.0962Z"
                stroke={couleur} strokeWidth="4" strokeLinejoin="round"/>
        </g>
        <defs>
            <clipPath id="clip0_3880_18558">
                <rect width="40" height="26.856" fill="white" transform="translate(0 0.572266)"/>
            </clipPath>
        </defs>
    </svg>
);

export default WidgetMeteo;
